// Module and submodule hierarchy for permissions
// Used by Owner (AMC Management), Admin (User Management), Sidebar, and ProtectedRoute

export const MODULE_HIERARCHY = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    submodules: [],
  },
  {
    id: 'funds',
    label: 'Funds',
    submodules: [],
  },
  {
    id: 'investments',
    label: 'Investments',
    submodules: [
      { id: 'transactions', label: 'Transactions' },
      { id: 'fmv', label: 'FMV' },
      { id: 'documents', label: 'Documents' },
      { id: 'portfolio', label: 'Portfolio' },
      { id: 'investment_summary', label: 'Investment Summary' },
    ],
  },
  {
    id: 'investors',
    label: 'Investors',
    submodules: [
      { id: 'investor_contacts', label: 'Investor Contacts' },
      { id: 'investor_accounts', label: 'Investor Accounts' },
      { id: 'investor_reports', label: 'Reports' },
    ],
  },
  {
    id: 'drawdowns',
    label: 'Drawdown Management',
    submodules: [],
  },
  {
    id: 'ai_certification',
    label: 'AI Certification',
    submodules: [],
  },
  {
    id: 'data_rooms',
    label: 'Data Rooms',
    submodules: [],
  },
  {
    id: 'compliance',
    label: 'Compliance Tracker',
    submodules: [],
  },
];

// Flat list of ALL module/submodule IDs
export const ALL_MODULE_IDS = MODULE_HIERARCHY.reduce((acc, mod) => {
  acc.push(mod.id);
  mod.submodules.forEach(sub => acc.push(sub.id));
  return acc;
}, []);

// Map submodule → parent module
export const SUBMODULE_PARENT = {};
MODULE_HIERARCHY.forEach(mod => {
  mod.submodules.forEach(sub => {
    SUBMODULE_PARENT[sub.id] = mod.id;
  });
});

/**
 * Compute effective permissions by intersecting AMC-level and user-level permissions.
 * A submodule is effective only if:
 *   1. AMC has the parent module enabled
 *   2. AMC has the submodule enabled
 *   3. User has the parent module enabled
 *   4. User has the submodule enabled
 *
 * @param {Object} userPerms - user.module_permissions (dict of booleans)
 * @param {string[]} amcEnabledModules - AMC enabled_modules list
 * @returns {Object} effective permissions dict
 */
export function computeEffectivePermissions(userPerms, amcEnabledModules) {
  const amcSet = new Set(amcEnabledModules || []);
  const effective = {};

  MODULE_HIERARCHY.forEach(mod => {
    const userHasModule = userPerms?.[mod.id] !== false;
    effective[mod.id] = userHasModule && amcSet.has(mod.id);

    mod.submodules.forEach(sub => {
      const userHasSub = userPerms?.[sub.id] !== false;
      effective[sub.id] = effective[mod.id] && userHasSub && amcSet.has(sub.id);
    });
  });

  return effective;
}
